import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  customers: [],
  customer: null,
  selectedCustomer: -1,
  selectedFacturaCustomer: -1,
  error: null
};

const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    selectedCustomerSuccess(state, action) {
      if (state.selectedCustomer === action.payload)
        state.selectedCustomer = -1;
      else state.selectedCustomer = action.payload;
    },

    selectedFacturaCustomerSuccess(state, action) {
      if (state.selectedFacturaCustomer === action.payload)
        state.selectedFacturaCustomer = -1;
      else state.selectedFacturaCustomer = action.payload;
    },

    // Reset directo (no-toggle) del cliente de factura. Se usa al abrir
    // el PaymentDialog y tras un cobro completo: el toggle de
    // `selectedFacturaCustomerSuccess` requiere conocer el valor actual
    // del state, que en closures de useEffect puede estar stale y
    // dejar el cliente "pegado" para el siguiente cobro.
    clearSelectedFacturaCustomer(state) {
      state.selectedFacturaCustomer = -1;
    },

    // GET LOGS
    getCustomersSuccess(state, action) {
      state.customers = action.payload;
    },

    getCustomerSuccess(state, action) {
      state.customer = state.customers.find((c) => c.id == action.payload);
    },

    addCustomerSuccess(state, action) {
      state.customers = [...state.customers, action.payload];
    },

    editCustomerSuccess(state, action) {
      state.customers = state.customers.map((c) => {
        if (c.id == action.payload.id) return action.payload;
        return c;
      });
    },

    deleteCustomerSuccess(state, action) {
      state.customers = state.customers.filter((c) => c.id != action.payload);
    },

    cleanCustomer(state, action) {
      state.customer = null;
      state.selectedCustomer = -1;
      state.selectedFacturaCustomer = -1;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCustomerSuccess,
  getCustomersSucces,
  addCustomerSuccess,
  editCustomerSuccess,
  selectedCustomerSuccess,
  deleteCustomerSuccess,
  selectedFacturaCustomerSuccess,
  clearSelectedFacturaCustomer,
  cleanCustomer
} = slice.actions;

// ----------------------------------------------------------------------

export function GetCustomers() {
  return async (dispatch) => {
    try {
      var response = await axios.get(`customers`);
      dispatch(slice.actions.getCustomersSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addCustomer(customer) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        'customers',
        JSON.stringify({
          ...customer
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
          }
        }
      );
      dispatch(slice.actions.addCustomerSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editCustomer(customer) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.editCustomerSuccess(customer));

      await axios.put(
        'customers',
        JSON.stringify({
          ...customer
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
          }
        }
      );
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteCustomer(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.deleteCustomerSuccess(id));
      await axios.delete(`customers/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': '*'
        }
      });
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
